import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import Link from '@ux/link';
import noop from 'lodash.noop';
import { Menu, MenuButton } from '@ux/menu';
import NavBarItemChildren from './NavBarItemChildren';
import AsyncIcon from '@ux/icon/async-icon.js';
import additionalIcons from '../icons';

import Tag from '@ux/tag';

const customIcons = { ...additionalIcons };

const NavBarItem = forwardRef((props, forwardedRef) => {
  const {
    icon = '',
    active = false,
    className = '',
    id = '',
    href = '#',
    target = null,
    dataAttrs = {},
    caption = null,
    title = null,
    eid = '',
    children = null,
    onClick = noop,
    badge = null
  } = props;

  const _className = classNames(
    'in-page-nav-item',
    { active },
    className
  );

  let iconJsx;
  if (icon) {
    const iconStyle = icon;
    const CustomIcon = customIcons[iconStyle];
    iconJsx = CustomIcon
      ? <CustomIcon alttext={ caption || title } className='in-page-nav-item-icon' />
      : <AsyncIcon icon={ iconStyle } alttext={ caption || title } className='in-page-nav-item-icon' />;
  }

  let badgeJsx = null;
  if (badge?.text) {
    badgeJsx = (
      <Tag type='highlight' size='sm'>
        { badge.text }
      </Tag>
    );
  }

  if (children && children.length) {
    return (
      <Menu ref={ forwardedRef } as='li' id='horizontal-nav' className={ _className }>
        <MenuButton icon={ <AsyncIcon icon='chevron-down' /> }>
          { iconJsx }
          { caption || title }
          { badgeJsx }
        </MenuButton>
        <NavBarItemChildren items={ children } />
      </Menu>
    );
  }
  return (
    <li ref={ forwardedRef } className={ _className }>
      <Link
        className='in-page-nav-link'
        id={ id }
        href={ href || '#' }
        target={ target }
        onClicked={ onClick }
        data-eid={ eid }
        { ...dataAttrs }
      >
        { iconJsx }
        { caption || title }
        { badgeJsx }
      </Link>
    </li>
  );

});

NavBarItem.propTypes = {
  icon: PropTypes.string,
  active: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  onClick: PropTypes.func,
  dataAttrs: PropTypes.shape({}),
  caption: PropTypes.node,
  title: PropTypes.node,
  eid: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.shape(NavBarItem.propTypes)),
  badge: PropTypes.shape({
    text: PropTypes.string
  })
};

const NavBarItemPropTypes = NavBarItem.propTypes;
export { NavBarItem as default, NavBarItemPropTypes };
